import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import type { RecoverableSession } from '../utils/assessmentSessionRecovery';
import { useFocusTrap } from '../../app/hooks/useFocusTrap';
import { useEscapeKey } from '../../app/hooks/useEscapeKey';
interface AssessmentRecoveryModalProps {
  session: RecoverableSession;
  onResume: () => void;
  onAbandon: () => void;
}
export function AssessmentRecoveryModal({
  session,
  onResume,
  onAbandon
}: AssessmentRecoveryModalProps) {
  const focusTrapRef = useFocusTrap(true);
  useEscapeKey(onAbandon);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" data-id="element-802" data-mp="1wioiz5q0gdjk" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-803" data-mp="1rk3j57eo7vvn">
        <div ref={focusTrapRef} className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 space-y-4" role="dialog" aria-modal="true" aria-labelledby="recovery-title" data-id="element-804" data-mp="25keb6drpvgie">
          <div className="flex items-center gap-3" data-id="element-805" data-mp="s2z1lehxf2pw">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center" data-id="element-806" data-mp="s4a1324c9ob7">
              <AlertCircle className="h-5 w-5 text-amber-600" data-id="element-807" data-mp="120d5yfqks11u" />
            </div>
            <div data-id="element-808" data-mp="122g5bqdmb6j8">
              <h2 id="recovery-title" className="text-lg font-bold text-gray-900" data-id="element-809" data-mp="16zgbs2edqbav">
                Toets hervatten?
              </h2>
              <p className="text-sm text-gray-500" data-id="element-810" data-mp="1ayyssn32y28f">
                Er is een onafgemaakte toets gevonden
              </p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-3 space-y-1" data-id="element-811" data-mp="1krw7ei4yb71r">
            <p className="text-sm text-gray-700" data-id="element-812" data-mp="1ppoam8b1qfl9">
              <strong data-id="element-813" data-mp="1ppej2gacs0dg">{session.attempt.answers.length}</strong> van{' '}
              <strong data-id="element-814" data-mp="1uptwf7umx7vf">{session.blueprint.questions.length}</strong> vragen
              beantwoord
            </p>
            <p className="text-xs text-gray-500" data-id="element-815" data-mp="1yrfdl5e7c8bf">
              Opgeslagen {Math.round((Date.now() - session.savedAt) / 60000)}{' '}
              minuten geleden
            </p>
          </div>

          <div className="flex gap-3" data-id="element-816" data-mp="3qt8emdam5zc7">
            <Button variant="secondary" onClick={onAbandon} className="flex-1" data-id="element-817" data-mp="3qqccsdvnaqih">
              Opnieuw beginnen
            </Button>
            <Button variant="primary" onClick={onResume} className="flex-1" data-id="element-818" data-mp="3mxv4ao01pw5">
              Hervatten
            </Button>
          </div>
        </div>
      </div>
    </>;
}